import React, { SyntheticEvent } from 'react'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from './field-instructions'
import Title from './field-title'

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceUrl?: string
    showInstructions?: boolean
    onChange: (sourceUrl: string) => void
}

const CreationSourceURLField = ({ className, field, sourceUrl = '', showInstructions = false, onChange }: Props) => {
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLInputElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <input
                {...{
                    defaultValue: sourceUrl,
                    type: 'url',
                    placeholder,
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
            {showInstructions && <Instructions field={field} />}
        </UploadFieldBlock>
    )
}

export default CreationSourceURLField
